import { Card, Alert, AlertTitle, Button } from "@mui/material";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { editAutorizacaoExercicio } from "../../../services/autorizacao.service";
import { ErrorBar } from "recharts";
import { useAutorizacoes } from "../../../hooks/useAutorizacoes";
import RestricaoOptions from "../../departamentos/dlif/licenciamento/auntorizacaoExercicio/components/restricaoOptions";
import AutorizacaoOptions from "../../departamentos/dlif/licenciamento/auntorizacaoExercicio/components/autorizacaoOptions";
import ButtonLeft from "../../../utils/buttonLeft";
import MessageError from "../../../messages/messageError";
import CreateOptionsAutorizacao from "../../departamentos/dlif/licenciamento/auntorizacaoExercicio/components/createOptionsAutorizacao";
import CreateOptionsRestricao from "../../departamentos/dlif/licenciamento/auntorizacaoExercicio/components/createOptionsRestricao";


export default function EditAutorizacaoExercicio({ estabelecimento, setIsEdit, autorizacao }) {
    const { id } = useParams();
    const dispatch = useDispatch();
    const user = useSelector(state => state.account.user);
    // const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')

    const [form, setForm] = useState({
        tipoAutorizacao: "",
        restricaoAutorizacao: "Nenhuma"
    });
    const [load, setLoad] = useState(false);

    const { options, restricoes } = useAutorizacoes(estabelecimento?.tipo?.designacao);

    const handleChange = e =>
        setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

    const handleEdite = async () => {
        try {

            setLoad(true);

            await editAutorizacaoExercicio({
                ...form,
                autorizacaoId: autorizacao._id,
                userId: user._id
            });

            setIsEdit(false);

            dispatch({
                type: "alert",
                payload: { alert: "Autorização editada com sucesso." }
            });


        } catch (err) {
            // console.error(err);
            setMessageError(ErrorBar.response.data.message)
        } finally {
            setLoad(false);
        }
    };

    return (
        <Card sx={{ p: 3 }}>
            {/* {messageSuccess && <MessageSuccess message={messageSuccess} />} */}
            {messageError && <MessageError message={messageError} />}

            <Alert severity="info">
                <AlertTitle>Tipo de Autorização</AlertTitle>
            </Alert>

            <CreateOptionsAutorizacao
                empresa={estabelecimento?.empresa?.nome}
                tipoEstabelecimento={estabelecimento?.tipo?.designacao}
            />

            <AutorizacaoOptions
                options={options}
                value={form.tipoAutorizacao}
                onChange={handleChange}
                empresa={estabelecimento?.empresa?.nome}
                tipoEstabelecimento={estabelecimento?.tipo?.designacao}
            />


            <Alert severity="info">
                <AlertTitle>Restrições</AlertTitle>
            </Alert>

            <CreateOptionsRestricao
                empresa={estabelecimento?.empresa?.nome}
                tipoEstabelecimento={estabelecimento?.tipo?.designacao}
            />

            <RestricaoOptions
                options={restricoes}
                value={form.restricaoAutorizacao}
                onChange={handleChange}
            />

            <ButtonLeft
                title={'Confirmar'}
                disabled={!form?.tipoAutorizacao}
                funcao={handleEdite}
                load={load}
            >
                <Button color="error" onClick={() => setIsEdit(false)} >Cancelar</Button>
            </ButtonLeft>
        </Card>
    );
}
